'use client';

import {
  FilterButton, IconAgenda, IconLink, SelectModal,
} from '@sympla/sympla-components';
import { ALGOLIA_INDEX_NAME } from 'constants/algolia';
import React, { useState } from 'react';
import { useSortBy } from 'react-instantsearch';

interface SortByItem {
  value: string;
  label: string;
}

interface SortByButtonProps {
  title: string;
  items: SortByItem[];
}

export function SortByFilter(props: SortByButtonProps) {
  const { title, items } = props;
  const [open, setOpen] = useState(false);

  const { options, currentRefinement, refine } = useSortBy({ items });

  const selectedOption = options.find((option) => option.value === currentRefinement);
  const currentLabel = selectedOption ? selectedOption.label : '';

  const handleSelect = ({ value }: { value: string }) => {
    refine(value);
    setOpen(false);
  };

  return (
    <>
      <FilterButton
        selectedItem={currentLabel}
        onClick={() => setOpen(true)}
        btnType="filter"
        upperCase={false}
        removeSelectedItem={() => {
          refine('');
          setOpen(false);
        }}
        showCancelButton={false}
      >
        {title}
      </FilterButton>
      <SelectModal
        open={open}
        border
        title={title}
        accessibilityTitle={title}
        onSelect={handleSelect}
        columns={{
          xs: 1,
          sm: 1,
          md: 1,
        }}
        options={options.map((option) => {
          if (option.value === ALGOLIA_INDEX_NAME) {
            return {
              icon: <IconLink width={24} height={24} />,
              label: 'Relevância',
              description: 'Eventos em alta na sua Região',
              value: ALGOLIA_INDEX_NAME,
              param: '',
            };
          } if (option.value === `${ALGOLIA_INDEX_NAME}_date_asc`) {
            return {
              icon: <IconAgenda width={24} height={24} />,
              label: 'Data',
              description: 'Eventos mais próximos de acontecer',
              value: `${ALGOLIA_INDEX_NAME}_date_asc`,
              param: '',
            };
          }
          return {};
        })}
        hideModal={() => setOpen(false)}
      />
    </>
  );
}
